import uploadFile from "../../../utilities/uploadFile";
import { CAR_IMAGE_DAMAGE_KEYS, CAR_IMAGE_WALKAROUND_KEYS, compactCarImages } from "./carImages";

export const buildCarImagesPayload = (uploaded) => {
    const merged = {};

    CAR_IMAGE_WALKAROUND_KEYS.forEach((key) => {
        if (uploaded[key]) merged[key] = uploaded[key];
    });

    if (uploaded.dashboard) {
        merged.dashboard = uploaded.dashboard;
    }

    const damageUrls = Object.keys(uploaded)
        .filter((key) => key.startsWith("damage"))
        .sort()
        .map((key) => uploaded[key])
        .filter(Boolean)
        .slice(0, CAR_IMAGE_DAMAGE_KEYS.length);

    damageUrls.forEach((url, index) => {
        merged[CAR_IMAGE_DAMAGE_KEYS[index]] = url;
    });

    return compactCarImages(merged);
};

export async function uploadCheckInImageFiles({ walkaroundFiles, dashboardFile }) {
    const uploaded = {};

    await Promise.all(
        Object.entries(walkaroundFiles || {}).map(async ([key, file]) => {
            if (!file) return;
            try {
                const url = await uploadFile(file, "reservationImages");
                if (url) uploaded[key] = url;
            } catch {
                // individual upload failures are skipped
            }
        }),
    );

    if (dashboardFile) {
        try {
            const dashboardUrl = await uploadFile(dashboardFile, "reservationImages");
            if (dashboardUrl) uploaded.dashboard = dashboardUrl;
        } catch {
            // skip dashboard upload failure
        }
    }

    return uploaded;
}
